<template>
  <div class="riot-bg"></div>
  <div class="riot">
    <el-icon size="30" @click="handleClose" color="#ffffff">
      <Close/>
    </el-icon>
    <div class="top"><img src="@/assets/web/tournaments/pic_bg.png" alt=""></div>

    <div class="list" v-if="list.length > 0">
      <div class="list-content">
        <div class="item flex" v-for="item in list" @click="handleSelected(item)">
          <div class="img">
            <img src="@/assets/web/tournaments/icon_quantou.png" alt="">
          </div>
          <div class="item-content">
            <p>{{ item.lolName }}</p>
            <p>Skip the truth</p>
          </div>
        </div>
      </div>
<!--      <div class="or">OR</div>-->
<!--      <div class="item flex add" @click="handleClick">-->
<!--        <div class="img">-->
<!--          <img src="@/assets/web/tournaments/icon_jiahao@2x.png" alt="">-->
<!--        </div>-->
<!--        <div class="item-content">-->
<!--          <p>Connect another Riot account</p>-->
<!--          <p>Add LoL to Challengermode with another Riot account.</p>-->
<!--        </div>-->
<!--      </div>-->
    </div>

    <div class="add-btn" v-else @click="handleClick">
      <img src="@/assets/web/tournaments/icon_quantou.png" alt="">
      <p>Add Summoner</p>
    </div>
  </div>
</template>
<script setup>
import {useStore} from "vuex";
import {inject, onMounted, ref} from "vue";
import {getAuthList} from "@/store/user/actions";

const store = useStore()
const list = ref([])
const matchDetail = inject('matchDetail')

const emit = defineEmits(['close','selected'])

console.log(matchDetail.value)
// 跳转json

onMounted(() => {
  const userData = JSON.parse(sessionStorage.getItem('userData'))
  store.dispatch('user/getAuthList',{memberCode: userData.user.memberCode})
      .then(res => {
        if(res){
          list.value.push(...res)
        }
      })
})


const handleClose = () => {
  emit('close')
}
1
const handleClick = () => {
  const userData = JSON.parse(sessionStorage.getItem('userData'))
  const jumpData = {
    // url: 'https://https://sidequesthub.com/tournaments/detail/1133?type=joinRitoSuccess',
    url: `https://sidequesthub.com/tournaments/detail/${matchDetail.value.match.id}?type=joinRitoSuccess`,
    uk: userData.user.memberCode,
  }
  store.dispatch('user/getRiotAuth', {state: JSON.stringify(jumpData),memberCode: userData.user.memberCode})
      .then(res => {
        if (res) window.location.href = res.url
      })
}

onMounted(() => {
  const state = getQueryVariable().state
  if (state) {
    window.close()
  }
})

const handleSelected = (item) => {
  emit('selected', item)
}

const getQueryVariable = () => {
  let href = window.location.href
  let query = href.substring(href.indexOf('?') + 1);
  let vars = query.split("&");
  let obj = {}
  for (var i = 0; i < vars.length; i++) {
    let pair = vars[i].split("=");
    obj[pair[0]] = pair[1]
  }
  return obj;
}
</script>
<style scoped lang="scss">
.riot-bg {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, .5);
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
}

.riot {
  width: 600px;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
  background: #262731;
  border-radius: 20px 20px 20px 20px;
  min-height: 370px;
  padding-bottom: 30px;

  :deep(.el-icon) {
    position: absolute;
    top: 14px;
    right: 14px;
  }

  .flex {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .add-btn{
    width: 480px;
    height: 40px;
    background: #D1363A;
    border-radius: 24px 24px 24px 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 53px auto 0;
    color: #ffffff;
    font-size: 16px;
    cursor: pointer;
    img{
      width: 22px;
      margin-right: 16px;
    }
  }

  .list {
    width: 480px;
    margin: 0 auto;
    overflow: hidden;

    .list-content{
      overflow-x: hidden;
      overflow-y: auto;
      width: 498px;
      max-height: 400px;
    }

    .item {
      width: 480px;
      height: 80px;
      border-radius: 10px 10px 10px 10px;
      border: 1px solid #5C5E69;
      padding: 0 24px;
      box-sizing: border-box;
      cursor: pointer;
      margin-bottom: 10px;

      .img{
        width: 45px;
        height: 45px;
        background: #D1363A;
        border-radius: 50%;
        line-height: 45px;
        text-align: center;
        img{
          display: inline-block;
          width: 22px;
        }
      }

      .item-content{
        margin-left: 16px;
        color: #808388;
        font-size: 12px;
        text-align: left;

        p:first-child{
          font-size: 18px;
          font-weight: bold;
          color: #ffffff;
        }
      }
    }

    .or{
      width: 480px;
      margin: 12px auto;
      font-size: 16px;
      color: #ffffff;
      position: relative;
      text-align: center;

      &:after,&:before{
        content: '';
        display: inline-block;
        width: 219px;
        height: 1px;
        background: #333540;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
      }

      &:after{
        right: 0;
      }

      &:before{
        left: 0;
      }
    }

    .add{
      .img{
        background: #36384A;
      }
    }
  }
}
</style>
